import { useMutation, useQueryClient } from "@tanstack/react-query";

import { banDealer, unbanDealer } from "@/api/mainDealers";
import { MainDealersQueryKeys } from "@/tanstackQuery/queries";

export const useBanDealer = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: banDealer,
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: [MainDealersQueryKeys.All],
      });
    },
  });
};

export const useUnbanDealer = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: unbanDealer,
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: [MainDealersQueryKeys.All],
      });
    },
  });
};
